import { TemplatePage } from './types';

const travelPage: TemplatePage = {
  header: {
    color: '#F4F4F4',
    icon: 'images/video-templates/travel-tourism.jpg',
    title: 'Travel & Tourism Video Templates Collection',
    title_meta: '50+ Free and Customizable Travel Video Templates',
    description_meta:
      'Discover the beauty and diversity of the world together with your audience. Create breathtaking videos about ' +
      'adventures, landmarks, and locals with Wave.video’s 50+ customizable travel video templates.',
    description:
      'Explore the beauty of the world and share your adventurous videos using these 50+ travel video templates. From ' +
      'travel tips to hotel reviews, you’ll find a template to turn your footage into a neat stylish video.'
  },
  footer: {
    category: 'Travel & Tourism',
    description:
      'With Wave.video’s customizable video templates you can amuse your audience with great branded videos content ' +
      'while saving time on the production. The collection of professionally made templates allows you to present your ' +
      'story the best way possible and wrap it with a beautiful and unique design. '
  },
  content: [
    {
      type: 'templates',
      title: 'travel',
      search: { category: '/Industries/Travel' }
    },
    {
      type: 'stocks',
      title: 'travel ',
      search: { name: 'travel' }
    },
    { type: 'calendar' }
  ]
};

export default travelPage;
